import { createContext, useContext } from 'react'
import { ApiClient, initApiClient } from '@frontend/lib/request'

import {
  DepartmentLimit,
  DepartmentLimitUpsertPayload,
  ListDepartmentLimitsFilters,
} from '@shared-types/calendar'
import { Collection, Identifier } from '@shared-types/util'

export interface DepartmentLimitClient {
  list: (
    departmentId: Identifier,
    filters?: ListDepartmentLimitsFilters
  ) => Promise<Collection<DepartmentLimit>>
  upsertdel: (
    departmentId: Identifier,
    payload: DepartmentLimitUpsertPayload
  ) => Promise<DepartmentLimit>
}

class DefaultDepartmentLimitClient implements DepartmentLimitClient {
  client: ApiClient

  constructor() {
    this.client = initApiClient({})
  }

  async list(
    departmentId: Identifier,
    filters?: ListDepartmentLimitsFilters
  ): Promise<Collection<DepartmentLimit>> {
    return this.client
      .get(`/calendar/departments/${departmentId}/limits`, { params: filters })
      .then((res) => res.data)
  }

  async upsertdel(
    departmentId: Identifier,
    payload: DepartmentLimitUpsertPayload
  ): Promise<DepartmentLimit> {
    return this.client
      .put(`/calendar/departments/${departmentId}/limits`, payload)
      .then((res) => res.data)
  }
}

const DepartmentLimitClientContext = createContext<DepartmentLimitClient>(
  new DefaultDepartmentLimitClient()
)

export function useDepartmentLimitClient() {
  return useContext(DepartmentLimitClientContext)
}
